export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13936.bcc21d73.jpg";